import application from 'application';
import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';
import internalEventCodes from 'event-system/codes/internal';

const POLL_EXPIRED = 'POLL_EXPIRED';
const UNKNOWN = 'UNKNOWN';

class ActivePollChoice {

  showVotingFailedReason(choice) {

    const reason = this.getActionFailedReason(choice);

    let message = 'Unable to vote. Reason: Poll expired';

    if (reason !== POLL_EXPIRED) {
      message = 'Unable to vote. Reason: unknown. Try again!';
    }

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message,
      seconds: 5,
      type: 'error'
    });

  }

  showDeleteVoteFailedReason(choice) {

    const reason = this.getActionFailedReason(choice);

    let message = 'Unable to delete vote. Reason: Poll expired';

    if (reason !== POLL_EXPIRED) {
      message = 'Unable to delete vote. Reason: unknown. Try again!';
    }

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message,
      seconds: 5,
      type: 'error'
    });

  }

  getActionFailedReason(choice) {

    if (choice.pollEndsAt <= Date.now()) {
      return POLL_EXPIRED;
    }

    return UNKNOWN;

  }

  async deleteVote(voterId, index, choices, poll, postId) {

    const pollId = poll._id;
    const choice = choices[index];
    const choiceId = choice._id;

    const result = await serverInterface.startup.community.deletePollVote(postId, pollId, choiceId);

    let decrement = 1;

    if (result === false) {
      // Rendering will be updated with poll expired, if expired
      decrement = 0;

      this.showDeleteVoteFailedReason(choice);

    }

    choice.votesCount = choice.votesCount - decrement;

    application.eventSystem.internal.emit(`${externalEventCodes.POST_POLL_CHOICE_VOTE_DELETED}:${pollId}`, {
      emitted: true,
      pollId,
      choiceId,
      voterId,
      poll: {
        ...poll,
        totalVotesCount: poll.totalVotesCount - decrement,
        choices
      }
    });

  }

  async addVote(voterId, index, choices, poll, postId) {

    const pollId = poll._id;
    const choice = choices[index];
    const choiceId = choice._id;

    const result = await serverInterface.startup.community.voteOnPoll(postId, pollId, choiceId);

    let increment = 1;

    if (result === false) {

      // Rendering will be updated with poll expired, if expired
      increment = 0;

      this.showVotingFailedReason(choice);

    }

    choice.votesCount = choice.votesCount + increment;

    application.eventSystem.internal.emit(`${externalEventCodes.POST_POLL_CHOICE_VOTE_ADDED}:${pollId}`, {
      pollId,
      choiceId,
      voterId,
      recasted: true,
      poll: {
        ...poll,
        totalVotesCount: poll.totalVotesCount + increment,
        choices
      }
    });

  }

  async handleChoiceButtonClick(index, choice, poll, event) {

    event.stopPropagation();

    if (application.isAuthenticated() === false) {
      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_AUTHENTICATOR);
      return;
    }

    const voterId = application.getUser()._id;
    const postId = choice.associatedToEntityId;
    const voterIds = choice.voterIds;

    const choices = poll.choices;

    if (voterIds.indexOf(voterId) !== -1) {

      await this.deleteVote(voterId, index, choices, poll, postId);

    } else {

      await this.addVote(voterId, index, choices, poll, postId);

    }

  }

}

export default ActivePollChoice;